import { visuallyHidden } from "plos/src/styles/utils.css";
import { useTranslation } from "react-i18next";
import FixtureDifficultyCell from "../../PlayerSheets/PlayerProfileSheet/Tables/custom-cells/FixtureDifficultyCell/FixtureDifficultyCell";
import {
  keyHeadingStyles,
  keyItemsStyles,
  keyLabelsStyles,
  keyLabelStyles,
  keyWrapperStyles,
} from "./fdrKey.css";

const FDRKey = () => {
  const { t } = useTranslation("fixturesAndFDR");
  const difficultyRating = [1, 2, 3, 4, 5];
  return (
    <div>
      <div className={keyWrapperStyles} data-testid="key">
        <div>
          <h3 className={keyHeadingStyles}>{t("fdrKey.title", "FDR Key:")}</h3>
        </div>
        <div>
          <div className={keyItemsStyles}>
            {difficultyRating.map((rating) => (
              <FixtureDifficultyCell
                key={rating}
                rating={rating as 1 | 2 | 3 | 4 | 5}
              />
            ))}
          </div>
        </div>
        <div className={keyLabelsStyles}>
          <span className={visuallyHidden}>
            {t("fdrKey.easy.label", "1 = Easy")}
          </span>
          <div className={keyLabelStyles}>{t("fdrKey.easy.text", "Easy")}</div>
          <span className={visuallyHidden}>
            {t("fdrKey.hard.label", "5 = Hard")}
          </span>
          <div className={keyLabelStyles}>{t("fdrKey.hard.text", "Hard")}</div>
        </div>
      </div>
    </div>
  );
};
export default FDRKey;
